// src/components/CertificationCTA.js
import React from 'react';
import { Award } from 'lucide-react';
import './BadgeCTA.css';
import Mental from './mentalstrength.png'
const CertificationCTA = ({
  title = "Elevate your workplace standards",
  subtitle = "Get certified in Occupational Health and Safety",
  buttonText = "Learn more",
  onButtonClick = () => { window.location.href = '/certification'; },
}) => {
  return (
    <section className="certification-section">
      <div className="gradient-background-cert" />

      <div className="content-wrapper-cert">
        <div className="grid-container-certification">
          <div className="content-container-cert">
            <div className="badge-pill">
              <Award className="badge-icon" />
              <span className="badge-text">Official Certification</span>
            </div>

            <h1 className="title">{title}</h1>
            <p className="subtitle">{subtitle}</p>

            <button onClick={onButtonClick} className="cta-button-mental">
              <span className="relative z-10">{buttonText}</span>
              <span className="button-highlight" />
            </button>
          </div>

          <div className="image-container-cert">
            <div className="image-wrapper-cert">
              <img
                src={Mental}
                alt="Professional team members reviewing safety certification documents"
                className="main-image"
              />
            </div>

            
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationCTA;
